import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import config from '../config/locales';

Vue.use(VueI18n);

const { locale, fallbackLocale, availableLocales } = config;

const messages: LocaleMessages = {};
availableLocales.forEach((el) => {
  messages[el.code] = el.messages;
});

export default new VueI18n({
  locale,
  fallbackLocale,
  messages,
  silentTranslationWarn: true,
});
